import React, { useState } from "react";
import { LessonArray } from "../constants/MockData";
import { handleGenerateContent } from "../api/generateContentApi";

const LessonGenerator = () => {
  const [data, setData] = useState({ grade: 0, week: 0 });

  const handleGetContent = (e) => {
    const { name, value } = e.target;
    const test = { ...data, [name]: Number(value) };
    setData(test);
  };
  const handleSubmitContent = () => {
    handleGenerateContent(LessonArray, data.grade, data.week);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        margin: 30,
      }}
    >
      <h1>Generate Content</h1>
      <div style={{ margin: 10 }}>
        <label>grade: </label>
        <input
          type="number"
          name="grade"
          defaultValue={data.grade}
          onChange={(e) => handleGetContent(e)}
        />
      </div>
      <div style={{ margin: 10 }}>
        <label>week: </label>
        <input
          type="number"
          name="week"
          defaultValue={data.week}
          onChange={handleGetContent}
        />
      </div>
      <button onClick={() => handleSubmitContent()}>submit content</button>
      {/* <span>{JSON.stringify(LessonArray, null, 2)}</span> */}
    </div>
  );
};

export default LessonGenerator;
